import defaultRules from './default';
import hover from './hover';

export default {
  default: defaultRules,
  hover,
};
